import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import Product from '../../../model/product/product';
import { DatePipe } from '@angular/common';
import { FormatDecimal } from '../../../pipes/format-decimal';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { FormatPhoneNumber } from 'src/app/modules/app-pipes/format-phonenumber';
import { Subject } from 'rxjs';
import { Project } from '../../../model/project/project';
import ProjectHelper from '../../../helpers/project-helper';
import { SubProject } from '../../../model/project/sub-project';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import Contact from 'src/app/model/Contact/contact';
import Company from 'src/app/model/company/company';
import { BoardPartAddedEvent } from 'src/app/events/board-part-added';
import { StandardStickerPartAddedEvent } from 'src/app/events/standard-sticker-part-added';
import { StandardStickerPartDeletedEvent } from 'src/app/events/standard-sticker-part-deleted';
import {
  GroupProjectContactPipe,
  ProjectContactGroup,
} from 'src/app/pipes/group-project-contact';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { AsyncChildRenderComponent } from 'src/app/subscription-helpers/async-child-render.component';
import { RENDER_CHILDREN_DELAY } from 'src/globals/globals';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { PrintAddressPipe } from 'src/app/pipes/print-address.pipe';
import { StringHelper } from 'src/app/helpers/string-helper';

@Component({
  selector: 'project-summary',
  templateUrl: './project-summary.component.html',
  styleUrls: ['./project-summary.component.scss'],
  providers: [
    FormatDecimal,
    FormatPhoneNumber,
    GroupProjectContactPipe,
    PrintAddressPipe,
  ],
})
export class ProjectSummaryComponent
  extends AsyncChildRenderComponent
  implements OnInit
{
  @Input()
  project: Project;
  @Input()
  inputProject: SubProject;
  @Input()
  productAdded: Subject<Product>;
  @Input()
  boardPartAdded: Subject<BoardPartAddedEvent>;
  @Input()
  standardStickerPartAdded: Subject<StandardStickerPartAddedEvent>;
  @Input()
  standardStickerPartDeleted: Subject<StandardStickerPartDeletedEvent>;
  @Input()
  client = false;
  @Input()
  involvedCompanies: Company[];
  @Input()
  invoiceSent: Subject<any>;
  @Output()
  outputProject = new EventEmitter();

  projectContactGroups: ProjectContactGroup[] = [];
  selectedOtherContacts: Contact[];
  totalExecutionTime: string;
  displayTotalExecutionTime: boolean = false;
  collectKeyFromAddress: string;

  constructor(
    public datepipe: DatePipe,
    private groupProjectContactPipe: GroupProjectContactPipe,
    private printAddressPipe: PrintAddressPipe,
    private projectDisplayObservableService: ProjectDisplayObservableService,
    public dialog: MatDialog
  ) {
    super();
  }

  ngOnInit() {
    this.calculateProjectContactGroups();
    this.calculateTotalExecutionTime();
    this.calculateCollectKeyFromAddress();
    setTimeout(() => {
      this.renderChildren.next(true);
    }, RENDER_CHILDREN_DELAY);
    this.addSubscription(
      this.projectDisplayObservableService.getProjectContactsChangedSubscribable(),
      () => {
        this.calculateProjectContactGroups();
      }
    );
    this.addSubscription(
      this.projectDisplayObservableService.getProjectPlacementVariableChangedSubscribable(),
      () => {
        this.calculateCollectKeyFromAddress();
      },
      () => {},
      500
    );
    if (this.client) {
      this.addSubscription(
        this.projectDisplayObservableService.getSelectedOtherContactsChangedSubscribable(),
        (contacts: Contact[]) => {
          this.selectedOtherContacts = contacts;
          this.calculateProjectContactGroups();
        }
      );
    }
  }

  mail(email: String, contact: Contact): String {
    return (
      'mailto:' +
      email +
      '?Subject= ' +
      ProjectHelper.getMailSubjectLine(this.project) +
      '&body=Beste ' +
      contact.firstName +
      ','
    );
  }

  formatDate(date: Date) {
    return this.datepipe.transform(date, 'dd/MM/yyyy');
  }

  calculateProjectContactGroups() {
    this.projectContactGroups = this.groupProjectContactPipe.transform(
      this.project.projectContacts
    );
    if (
      this.client &&
      CollectionHelper.isPopulated(this.selectedOtherContacts) &&
      CollectionHelper.isPopulated(this.projectContactGroups)
    ) {
      const firstGroup = this.projectContactGroups[0];
      if (firstGroup.contacts == null) {
        firstGroup.contacts = [];
      }
      firstGroup.contacts.push(...this.selectedOtherContacts);
    }
  }

  calculateTotalExecutionTime() {
    this.totalExecutionTime = GeneralHelper.getMinutesInHourAndMinutes(
      ProjectHelper.getTotalProjectExecutionMinutes(
        this.inputProject.projectPlacement
      )
    );
    this.displayTotalExecutionTime =
      CollectionHelper.isPopulated(this.project.products) &&
      this.project.products.every(
        (p) =>
          p.productPlacement != null &&
          p.productPlacement.executionComplete === true
      );
  }

  calculateCollectKeyFromAddress() {
    if (
      this.inputProject.projectPlacement != null &&
      this.inputProject.projectPlacement.collectKey &&
      !StringHelper.isEmpty(
        this.inputProject.projectPlacement.collectKeyExtraInfo
      )
    ) {
      this.collectKeyFromAddress =
        this.inputProject.projectPlacement.collectKeyExtraInfo;
    } else {
      const address = <any>(
        ProjectHelper.getKeyCollectionAddress(this.inputProject, this.project)
      );

      this.collectKeyFromAddress =
        address == null
          ? null
          : this.printAddressPipe.transform(
              address.line1,
              address.postalCode,
              address.city
            );
    }
  }
}
